import { DateTime } from "luxon";

export interface AccessToken {
    sid: string;
    sub: string;
    aud: string[];
    exp: number;
    scope: string[];
    authTime: DateTime;
    expiration: DateTime;
    userEmail: string;
    userFirstName: string;
    userLastName: string;
    idsClientId: string;
    planId: number;
    tenant: string;
    viewPhi: boolean;
    centerId: number;
    permission: string | string[];
    identityProvider: string;
}

export type TokenClaim = keyof AccessToken;
export const claimNames: Record<TokenClaim, string> = {
    sid: "SID",
    sub: "SUB",
    aud: "Audience",
    exp: "Expire",
    scope: "Scope",
    authTime: "Auth Time",
    expiration: "Expiration",
    userEmail: "Email",
    userFirstName: "First Name",
    userLastName: "Last Name",
    idsClientId: "IDsClientID",
    planId: "Plan ID",
    tenant: "Tenant",
    viewPhi: "View PHI",
    centerId: "Center ID",
    permission: "Permission List",
    identityProvider: "Identity Provider",
};

export interface IAzaraAccessToken {
    amr: string[];
    aud: string[];
    auth_time: number;
    center_id: string;
    client_id: string;
    exp: number;
    family_name: string;
    given_name: string;
    iat: number;
    idp: string;
    iss: string;
    jti: string;
    limited_access_user: "True" | "False";
    name: string;
    nbf: number;
    plan_id: string;
    scope: string[];
    sid: string;
    sub: string;
    tenant: string;
    view_phi: "True" | "False";
    permission: string | string[];
}
